import React, {FC} from 'react';

import {Icon, Question} from '@optimaxdev/icons';

import classNames from 'classnames';

import {useFeature} from 'components/feature';
import {Price} from 'components/price/price';

import s from './shippingContent.scss';

type PropsType = {
    price: number;

    modalHandler: () => void;
};

/**
 * ToggleShippingContent render shipping content
 */
export const ToggleShippingContent: FC<PropsType> = ({modalHandler, price}) => {
    const isFacelift = useFeature('dCheckoutFacelift');

    return (
        <p
            className={classNames(s.textContentContainer, {
                [s.textContentContainerFacelift]: isFacelift,
            })}
        >
            <span className={classNames(s.title, {[s.titleFacelift]: isFacelift})}>
                {isFacelift ? (
                    <>
                        Shipping Protection (+ <Price>{price}</Price>)
                    </>
                ) : (
                    <>
                        Get Shipping Protection for just <Price>{price}</Price>
                    </>
                )}
            </span>
            <span className={s.text}>
                {isFacelift
                    ? 'From damage, loss, or theft.'
                    : 'Protect your shipment from damage, loss, or theft.'}
                <button className={s.learnMore} onClick={modalHandler} type="button">
                    {isFacelift ? 'Learn more' : <Icon className={s.iconHelp} icon={Question} />}
                </button>
            </span>
        </p>
    );
};
